import { ReactNode } from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ $collapseOnWidth: number; $isLast: boolean }>`
  border-bottom: solid 2px var(--border-color);
  padding: 1.5rem;
  
  ${(props) =>
    props.$isLast
      ? "border-bottom: none;"
      : "border-bottom: solid 2px var(--border-color);"}
  
  @media (min-width: ${(props) => props.$collapseOnWidth}px) {
    border: solid 2px var(--border-color);
    margin-top: 1rem;
    margin-bottom: 1rem;
    ${(props) => (props.$isLast ? "" : "border-bottom: solid 2px var(--border-color);")}  
  }
`;

const Header = styled.h1`
  margin-bottom: 1.5rem;
`;

const Header2 = styled.h2`
  margin-bottom: 1.5rem;
`;

interface CardProps {
  children?: ReactNode;
  title: string;
  collapseOnWidth?: number;
  isLast?: boolean;
  headingLevel?: 1 | 2;
}

const Card = (props: CardProps) => {
  const { children, title, collapseOnWidth = 0, isLast = false, headingLevel = 1 } = props;
  const HeaderElement = headingLevel === 2 ? Header2 : Header;

  return (
    <Wrapper $collapseOnWidth={collapseOnWidth} $isLast={isLast}>
      <HeaderElement>{title}</HeaderElement>
      {children}
    </Wrapper>
  );
};

export default Card;
